import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LineEnvelopeIcon from 'components/Luxkit/Icons/line/LineEnvelopeIcon'
import TextLink from '../../Luxkit/TextLink'
import BodyText from '../../Luxkit/Typography/BodyText'
import SupportNumberButton from '../../Luxkit/Button/SupportNumberButton'
import { useTranslation } from 'react-i18next'

const StyledPane = styled(Pane)`
  margin-top: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.large};
`

const StyledBody = styled(PaneBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > * + * {
    margin-top: ${rem(12)};
  }
`

interface Props {
  heading?: string;
  contactNumber?: App.GeoContact;
  email?: string;
  refCode?: string;
  onSupportEmailClick?: () => void;
  onSupportNumberClick?: () => void;
}

function HelpPane({ heading = 'Need help? Call our support team', contactNumber, email, refCode, onSupportEmailClick, onSupportNumberClick }: Props) {
  const { t } = useTranslation('common')
  return <StyledPane type="light">
    <StyledBody size="md">
      <BodyText variant="large" weight="bold">{t(heading)}</BodyText>
      <BodyText variant="medium">
        {t('customerServiceAvailable')}
      </BodyText>
      <SupportNumberButton onClick={() => onSupportNumberClick?.()} currentContact={contactNumber} />
      {email && <TextLink onClick={() => onSupportEmailClick?.()} startIcon={<LineEnvelopeIcon />} variant="black" href={`mailto:${email}`} rel="nofollow">{t(email)}</TextLink>}
      {refCode && <div>
        <BodyText variant="large" align="center" weight="bold">{t('Reference Code')}</BodyText>
        <BodyText variant="large">{t(refCode)}</BodyText>
      </div>}
    </StyledBody>
  </StyledPane>
}

export default React.memo(HelpPane)
